import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#F3F2F1"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.408 29L12.08 12.68H18.368L22.04 29H18.728L18.08 26.048H12.368L11.72 29H8.408ZM14.648 15.416L12.992 23.168H17.456L15.8 15.416H14.648Z",
      fill: "#003D69"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#006EC7"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#C8B600"
    }, null, -1)
  ])))
}
export default { render: render }